import { render, staticRenderFns } from "./BaseQuill.vue?vue&type=template&id=3bfccbde&scoped=true&"
import script from "./BaseQuill.vue?vue&type=script&lang=js&"
export * from "./BaseQuill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfccbde",
  null
  
)

export default component.exports